import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../';
import { ActivityLogTableList } from './ActivityLogTableList';
import { useActivityLogFilterParams, useProfileIsRight } from '../../hooks';
import { cleanActivityLogRelationSelectAndStore, getActivityLogRelationSelect } from '../../middleware';

export const ActivityLogList: React.FC = observer(() => {
    const filterParams = useActivityLogFilterParams();
    const isLord = useProfileIsRight('LORD');

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanActivityLogRelationSelectAndStore}
                filterParams={filterParams}
                getRelationSelect={getActivityLogRelationSelect}
                isNotFilterToolbar={!isLord}
            >
                <ActivityLogTableList />
            </ListWrapper>
        </Catcher>
    );
});
